var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroundFloor(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 169,
    height: 171,
    viewBox: "0 0 169 171",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8828 126.75L23.7285 118.927L0 105.625L87.1406 54.1328L169 105.625L146.641 118.969L159.758 126.75L87.1406 170.32L11.8828 126.75Z",
    fill: "#C4C4C4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.266V44.8906L85.8203 93.7422L169 44.8906V108.266L85.8203 157.117L0 108.266Z",
    fill: "#FFA621"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0 108.266V44.8906L85.8203 93.7422V157.117L0 108.266Z",
    fill: "#ED8E00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5 0L0 44.8906L85.8203 95.0625L169 44.8906L84.5 0Z",
    fill: "#FFC774"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M121.469 136.064V105.625L138.633 95.0625L139.953 125.43L121.469 136.064Z",
    fill: "#FFE3BA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroundFloor);
export default __webpack_public_path__ + "static/media/ground_floor.51c9d1a5d4ab85c4258e7313cfac2a71.svg";
export { ForwardRef as ReactComponent };